// @ts-strict-ignore
import React from "react";
import { Link } from "react-router-dom";
import withStyles from "isomorphic-style-loader/withStyles";

import classes from "./styles.scss";

interface Props {
	label?: string;
	text?: string;
	type?: "button" | "submit" | "reset";
	isLink?: boolean;
	isRouterLink?: boolean;
	isSubmitButton?: boolean;
	linkTo?: string;
	openInNewTab?: boolean;
	onClick?: (event?) => void;
	className?: string;
	disabled?: boolean;
	children?: React.ReactNode;
	dataCyAffix?: string;
}

const disableLinkFunc = () => {};

const Button = (props: Props) => {
	const {
		label,
		type,
		isLink,
		isRouterLink,
		isSubmitButton,
		linkTo,
		openInNewTab,
		onClick,
		className,
		disabled,
		btnRef,
		children,
		dataCyAffix,
		...otherProps
	} = props;

	const buttonClasses = [classes.button];

	if (disabled) {
		buttonClasses.push(classes.disabled);
	}

	if (className) buttonClasses.push(className);

	let linkProps = {};

	if (openInNewTab) {
		linkProps = {
			rel: "noopener noreferrer",
			target: "_blank"
		};
	}

	let button;

	const dataCy = dataCyAffix ? `${label}-${dataCyAffix}` : label;

	if (isLink) {
		button = (<a
			className={buttonClasses.join(" ")}
			href={linkTo}
			ref={btnRef}
			data-cy={dataCy}
			{...linkProps}
			{...otherProps}
			{...disabled ? { onClick: disableLinkFunc } : {}}
		>
			{label || children}
		</a>);
	} else if (isRouterLink) {
		button = (
			<Link
				className={buttonClasses.join(" ")}
				to={linkTo}
				ref={btnRef}
				data-cy={dataCy}
				{...linkProps}
				{...otherProps}
				{...disabled ? { onClick: disableLinkFunc } : {}}
			>
				{label || children}
			</Link>
		);
	} else if (isSubmitButton) {
		button = (
			<input
				type="submit"
				data-cy={dataCy}
				disabled={disabled}
				className={buttonClasses.join(" ")}
				value={label}
				ref={btnRef}
				{...otherProps}
			/>
		);
	} else if (label) {
		button = (<button
			type={type}
			data-cy={dataCy}
			className={buttonClasses.join(" ")}
			onClick={onClick}
			disabled={disabled}
			ref={btnRef}
			{...otherProps}
		>
			{label}
		</button>);
	} else {
		button = (
			<button
				type={type}
				className={buttonClasses.join(" ")}
				onClick={onClick}
				disabled={disabled}
				ref={btnRef}
				{...otherProps}
			>
				{children}
			</button>
		);
	}

	return button;
};

export default withStyles(classes)(Button);
